import Icon from './Icon';
import { isTelegram } from './telegram';

interface Props {
  /** Только для веба: возврат к форме входа — попробовать снова после одобрения. */
  onBack?: () => void;
}

/**
 * Заглушка для аккаунта, которому ещё не открыт доступ.
 *
 * Показывается вместо всего приложения — не только сразу после регистрации,
 * но и при каждой попытке входа, пока модератор не одобрит заявку (см.
 * `PENDING_APPROVAL` в App.tsx и Login.tsx). Никаких сетевых запросов здесь
 * не делается: пока аккаунт неактивен, `requireAuth` на сервере отклоняет
 * буквально всё, включая `/settings`.
 */
export default function PendingApproval({ onBack }: Props) {
  return (
    <div className="auth-shell">
      <div className="card" style={{ textAlign: 'center' }}>
        <div className="welcome__logo" aria-hidden style={{ margin: '0 auto 16px' }}>
          <Icon name="clock" size={30} />
        </div>

        <h2>Заявка на рассмотрении</h2>
        <p className="meta" style={{ marginBottom: 16 }}>
          Регистрация принята. Администратор проверит заявку и откроет
          доступ — обычно это быстро.
        </p>

        {isTelegram ? (
          <p className="meta">
            Ничего делать не нужно: как только доступ откроют, откройте
            приложение из бота ещё раз.
          </p>
        ) : (
          <>
            <p className="meta" style={{ marginBottom: 16 }}>
              Как только доступ откроют, войдите тем же логином и паролем.
            </p>
            {onBack && (
              <button className="secondary" onClick={onBack}>
                Назад к входу
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
